<div class="grid">
  <div class="col-12">
    <div class="ml-2 mt-2 mb-2">
      <p>{{notesMessage}}</p>
      <textarea id="notes" rows="5" cols="30" pInputTextarea [(ngModel)]="notes"></textarea>
    </div>
    <div class="flex justify-content-start ml-2">
      <div class="flex flex-column gap-1">
        <div><i class="pi pi-map-marker icon"></i> {{station?.Location?.Desc}}</div>
        <div><i class="pi pi-bullseye icon"></i> {{station?.Name}}</div>
        <div><i class="pi pi-calendar-clock icon"></i> {{date?.toLocaleDateString()}}, {{time?.formatedTimeAndRate}}</div>
        <div><i class="pi pi-clock icon"></i> {{duration}} Hours</div>
        <div><i class="pi pi-user icon"></i> {{guests}} guests</div>
        <div><i class="pi pi-shield icon"></i> Safety Officer {{needsRso ? 'Yes' : 'No'}}</div>
      </div>
    </div>
    <p-dataView #dv [value]="items" [lazy]="true">
      <ng-template let-items pTemplate="listItem">
        @for (item of items; track item.Pk; let first = $first) {
        <div class="col-12">
          <div class="flex flex-column xl:flex-row xl:align-items-start p-1 gap-1" [ngClass]="{ 'border-top-1 surface-border': !first }">
            <div class="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-1">
              <div class="">{{ item.Description }}</div>
              <div class="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
                <span class="">
                  {{(item.Price * item.cartQty) | currency}}
                </span>
                <span>
                  Qty: {{item.cartQty}}
                </span>
              </div>
            </div>
          </div>
        </div>
        }
      </ng-template>
    </p-dataView>
  </div>
</div>
<div class="text-right text-2xl font-semibold pr-3">Sub Total: {{totals.items | currency}}</div>
<div class="text-right text-2xl font-semibold pr-3">Tax: {{totals.tax | currency}}</div>
<p-divider></p-divider>
<div class="text-right text-3xl font-semibold pr-3 mb-2">Total: {{totals.total | currency}}</div>
<div class="text-right text-3xl font-semibold pr-3">
  <p-button (onClick)="onCompleteClick()" [loading]="isProcessing" [disabled]="isProcessing" label="CHECKOUT"></p-button>
</div>
<p-dialog header="Error" [(visible)]="showError">
  <p>
    Your payment was declined.
  </p>
</p-dialog>